import React from 'react';
import { Box, Typography, IconButton, useTheme } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import StoreIcon from '@mui/icons-material/Store';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import { useNavigate } from 'react-router-dom';
import { useBranch } from '../contexts/BranchContext';
import { useAuth } from '../contexts/AuthContext';
import { useSocket } from '../contexts/SocketContext';

const AppHeader = ({ title, showBack = false, onBack, rightIcon }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { restaurantName, selectedBranch, listenAllMode, setBranchSelectModalVisible } = useBranch();
  const { user } = useAuth();
  const { connected } = useSocket();

  const handleSettingsClick = () => {
    navigate('/settings');
  };

  return (
    <Box
      sx={{
        bgcolor: '#fff',
        px: 2,
        py: 1.5,
        borderBottom: '1px solid',
        borderColor: '#E5E7EB',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        {showBack && (
          <IconButton
            onClick={onBack || (() => navigate(-1))}
            sx={{ 
              bgcolor: '#F3F4F6',
              '&:hover': { bgcolor: '#E5E7EB' }
            }}
          >
            <Box component="span" sx={{ fontSize: 20 }}>←</Box>
          </IconButton>
        )}
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: '50%',
            bgcolor: '#851E41',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <RestaurantIcon sx={{ color: '#fff', fontSize: 22 }} />
        </Box>
        <Box>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              fontSize: title ? 18 : 16,
              color: '#1F2937',
              lineHeight: 1.2,
            }}
          >
            {title || restaurantName || 'Restaurant Dashboard'}
          </Typography>
          {selectedBranch && !title && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.25 }}>
              <Typography variant="body2" sx={{ color: '#6B7280', fontSize: 12 }}>
                {selectedBranch.name}
              </Typography>
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  bgcolor: connected ? '#10B981' : '#EF4444',
                }}
              />
              <Typography variant="body2" sx={{ color: connected ? '#10B981' : '#EF4444', fontSize: 10 }}>
                {connected ? 'Live' : 'Offline'}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {listenAllMode && (
          <Box
            onClick={() => setBranchSelectModalVisible(true)}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.75,
              bgcolor: '#059669',
              px: 1.5,
              py: 0.75,
              borderRadius: 3,
              cursor: 'pointer',
              '&:hover': { bgcolor: '#047857' },
            }}
          >
            <Typography sx={{ color: '#fff', fontSize: 12, fontWeight: 600 }}>ALL</Typography>
          </Box>
        )}
        {selectedBranch && !listenAllMode && (
          <Box
            onClick={() => setBranchSelectModalVisible(true)}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.75,
              bgcolor: '#851E41',
              px: 1.5,
              py: 0.75,
              borderRadius: 3,
              cursor: 'pointer',
              '&:hover': { bgcolor: '#6B1830' },
            }}
          >
            <StoreIcon sx={{ fontSize: 16, color: '#fff' }} />
            <Typography sx={{ color: '#fff', fontSize: 13, fontWeight: 500, maxWidth: 120 }} noWrap>
              {selectedBranch.name}
            </Typography>
            <Box component="span" sx={{ color: 'rgba(255,255,255,0.7)', fontSize: 18 }}>▾</Box>
          </Box>
        )}
        {rightIcon}
        <IconButton
          onClick={handleSettingsClick}
          sx={{ 
            bgcolor: '#F3F4F6',
            '&:hover': { bgcolor: '#E5E7EB' }
          }}
        >
          <SettingsIcon sx={{ color: '#6B7280', fontSize: 20 }} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default AppHeader;